import React from 'react';
import { Truck, Bus, Car, Tractor, Building2 } from 'lucide-react';
import { vehicleTypes, brands } from '../data/mock';

const icons = { Truck, Bus, Car, Tractor, Building2 };

const VehicleCard = ({ v }) => {
  const Icon = icons[v.icon];
  return (
    <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-6 text-center hover:border-[#FF6B00] hover:-translate-y-1 transition-all duration-300" data-testid={`vehicle-${v.icon.toLowerCase()}`}>
      <div className="w-16 h-16 mx-auto bg-[#FF6B00]/10 rounded-full flex items-center justify-center mb-4">
        <Icon className="text-[#FF6B00]" size={30} />
      </div>
      <h3 className="text-white font-bold text-base mb-1">{v.title}</h3>
      <p className="text-gray-500 text-sm">{v.text}</p>
    </div>
  );
};

const BrandsSection = () => (
  <section id="brands" className="py-24 bg-[#111111]" data-testid="brands-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <span className="text-[#FF6B00] font-bold text-sm uppercase tracking-wider">Marcas e Veículos</span>
        <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
          Atendemos todas as marcas de <span className="text-[#FF6B00]">veículos movidos a diesel</span>
        </h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 mb-14">
        {vehicleTypes.map((v) => <VehicleCard key={v.icon} v={v} />)}
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3" data-testid="brands-list">
        <span className="text-gray-500 text-sm uppercase tracking-wider mr-2">Marcas atendidas:</span>
        {brands.map((b) => (
          <span key={b} className="px-5 py-2 rounded-full border border-[#2a2a2a] bg-[#0a0a0a] text-white font-semibold text-sm hover:border-[#FF6B00] transition-colors">
            {b}
          </span>
        ))}
        <span className="px-5 py-2 rounded-full border border-dashed border-[#FF6B00]/50 text-[#FF6B00] text-sm">e todas as outras</span>
      </div>
    </div>
  </section>
);

export default BrandsSection;
